import { render, staticRenderFns } from "./QueueManagmentIndex.vue?vue&type=template&id=ab2cec28"
import script from "./QueueManagmentIndex.vue?vue&type=script&lang=ts"
export * from "./QueueManagmentIndex.vue?vue&type=script&lang=ts"
import style0 from "./QueueManagmentIndex.vue?vue&type=style&index=0&id=ab2cec28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports